import React from 'react';
import PropTypes from 'prop-types';
import { ErrorText } from '../ErrorText';
import { VisuallyHidden } from '../VisuallyHidden';
import {
  StyledRadioInput,
  StyledFieldset,
  StyledLegend,
  StyledCard,
  StyledHeading,
  StyledSubheading,
  StyledImage,
  Label,
} from './styles.js';

export const RadioImageCard = ({
  choices,
  value,
  name,
  legendText,
  onChange,
  disabled,
  direction = 'row',
  error,
  onClick,
}) => {
  return (
    <StyledFieldset>
      <StyledLegend>{legendText}</StyledLegend>
      <StyledRadioInput direction={direction}>
        {choices.map(choice => {
          const checked = value === choice.value;
          return (
            <StyledCard key={choice.value} checked={checked}>
              {choice.image && (
                <StyledImage
                  src={choice.image}
                  alt={choice.name}
                  width={95}
                  height={95}
                />
              )}
              <StyledHeading>{choice.name}</StyledHeading>
              {choice.description && (
                <StyledSubheading>{choice.description}</StyledSubheading>
              )}
              <Label
                checked={checked}
                disabled={disabled && !checked}
                error={error}
                htmlFor={`${name}-${choice.value}`}
                key={choice.value}
              >
                <VisuallyHidden>
                  <input
                    type="radio"
                    value={choice.value}
                    checked={checked}
                    id={`${name}-${choice.value}`}
                    onChange={e => onChange(e.target.value)}
                    error={error}
                    onClick={onClick}
                    disabled={disabled && !checked}
                  />
                </VisuallyHidden>
                {checked ? 'Selected' : 'Select'}
              </Label>
            </StyledCard>
          );
        })}
      </StyledRadioInput>
      {error && <ErrorText>{error}</ErrorText>}
    </StyledFieldset>
  );
};

RadioImageCard.propTypes = {
  name: PropTypes.string.isRequired,
  choices: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      image: PropTypes.object.isRequired,
      description: PropTypes.string.isRequired,
    }),
  ).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  direction: PropTypes.oneOf(['row', 'column']),
  error: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  legendText: PropTypes.string,
};
